/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CloseAll/view.blocks to change it.
import React from 'react'
import Tab from './Tab/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CloseAll({
  children,
  viewPath = "/App/Account/Topbar/Tabs/More/Content/CloseAll"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="CloseAll.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Tab
  viewPath={`${viewPath}/Tab`}
/>
</div>
{children}
</React.Fragment>)
}